import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

export const ItemListStyles = styled.div`
  position: absolute;
  z-index: 9;
  background-color: white;
  border: 1px solid ${Colors.accent.grey5.standard};

  left: ${(props) => (props.xOffset ? props.xOffset : 0)}px;
  top: 50px;

  &.item-list-container {
    overflow-y: auto;
    position: absolute;
  }

  &.item-list-container::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 5px;
  }
  &.item-list-container::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: lightgray;
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }

  .item-list-wrap {
    position: relative;
    width: ${(props) => (props.listWidth ? props.listWidth : 235)}px;
    ul {
      padding-inline-start: 0;
      list-style-type: none;
      max-height: 400px;

      li {
        background-color: white;
        font-size: 12px;
        line-height: 20px;
        margin: 2px;
        text-align: left;
        letter-spacing: normal;
        text-transform: none;

        a {
          padding: 5px 15px;
          cursor: pointer;
          display: block;
          text-decoration: none;

          &.selected {
            background-color: ${Colors.primary.claytonBlue.standard};
            > p {
              color: white;
            }
          }
        }
      }

      a:focus,
      a:hover {
        background-color: ${Colors.primary.claytonBlue.tint};
      }
    }
  }
`;
